import React, { useEffect, useState } from "react";
import "./Css/WPQgroove_pdf.css";
import { Modal } from "react-bootstrap";
import { jsPDF } from "jspdf";
import BarLoader from "react-spinners/BarLoader";
import Groove_pdf_page1WPQ from "./Pages/Groove_pdf_page1WPQ";
import { getdetailsById } from "../../../Services/wpq_details-service";
import { getbyrecordno } from "../../../Services/wpq_groove-services";
import WPQTubeToTubesheet_pdf_page1 from "./Pages/WPQTubeToTubesheet_pdf_page1";
import WPQTubeToTubesheet_pdf_page2 from "./Pages/WPQTubeToTubesheet_pdf_page2";
import Jspdf_font from "../../../Assests/font/jsPdf_font";
import { getImage } from "../WPQObjects/WPQCommonUtils";
import { getActiveProcess } from "../../../Services/weldingprocess-services";

const Pdf_DownloadWPQ = (props, wld) => {
  const [showSuccessModel] = useState(false);
  const [showForm] = useState(false);
  const [showConfirmModel] = useState(false);
  const [loading, setLoading] = useState(true);
  const [PreviewUrl, setPreviewUrl] = useState("");
  const [previewUrl1, setPreviewUrl1] = useState("");
  const [previewUrl2, setPreviewUrl2] = useState("");
  const [pdf, setpdf] = useState([]);
  const [previewuser, setPreviewuser] = useState("");
  const [previewapproved, setPreviewapproved] = useState("");
  let folderwld = "wld_signatures"
  let folderwpq = "WPQ_Groove"

  const fetchbyid = async (IddetailPK, IddetailSK) => {
    const result = await getdetailsById(IddetailPK, IddetailSK);
    const wpqhead = await getbyrecordno(props.WPQtype, IddetailPK, IddetailSK);
    let procData = await getActiveProcess();
    if (procData?.length > 0) {
      for (let item of result) {
        let reqProcess = procData.filter((element) => element.wld_code === item.WPQ_Process);
        item.WPQD_WP_WeldingProcess = reqProcess[0].wld_p_category;
      }
    }

    const processOrder = wpqhead[0]?.WPSH_WPQ_Process;
    let sortedResult = result;
    if (processOrder) {
      const orderList = processOrder.split(",").filter(Boolean);
      sortedResult = orderList
        .map(process => result.find(item => item.WPQ_Process === process))
        .filter(Boolean);
    }

    setpdf([...wpqhead, ...sortedResult]);
  };

  const createPDF = () => {
    fetchbyid(props?.rowdata?.WPQ_WelderId, props?.rowdata?.WPQ_RecordNo);
  };

  useEffect(() => {
    createPDF();
  }, []);

  // const fetchimagespdf = async () => {
  //   try {
  //     console.log("props", props?.rowdata)
  //     getImage(props?.rowdata?.Pdf_images[0].tube_Hole_ligament[0], folderwpq, setPreviewUrl)
  //     getImage(props?.rowdata?.Pdf_images[1].tube_Hole[0], folderwpq, setPreviewUrl1)
  //     getImage(props?.rowdata?.Pdf_images[2].tube_Weld_Joint[0], folderwpq, setPreviewUrl2)
  //   }
  //   catch (e) {
  //     console.log(e)
  //   }
  // }

  const fetchimagespdf = async () => {
    try {
      // Check both props.rowdata and pdf[0] for image data
      let imageData = props?.rowdata?.Pdf_images || pdf[0]?.Pdf_images;
      
      if (imageData && imageData.length > 0) {
        // Image 1: tube_Hole_ligament
        if (imageData[0]?.tube_Hole_ligament?.[0]) {
          await getImage(imageData[0].tube_Hole_ligament[0], folderwpq, setPreviewUrl);
        }

        // Image 2: tube_Hole
        if (imageData[1]?.tube_Hole?.[0]) {
          await getImage(imageData[1].tube_Hole[0], folderwpq, setPreviewUrl1);
        }

        // Image 3: tube_Weld_Joint
        if (imageData[2]?.tube_Weld_Joint?.[0] && imageData[2].tube_Weld_Joint[0] !== "") {
          await getImage(imageData[2].tube_Weld_Joint[0], folderwpq, setPreviewUrl2);
        }
      }
    }
    catch (e) {
      console.error("Error in fetchimagespdf:", e);
    }
  }

  // const fetchapproveUserProfileswld = async () => {
  //   getImage(props?.rowdata?.wpq_signaturePrepared, folderwld, setPreviewuser)
  // };

  const fetchapproveUserProfileswld = async () => {
     // Check both props.rowdata and pdf[0] for signature data
    let preparedSignature = props?.rowdata?.wpq_signaturePrepared || pdf[0]?.wpq_signaturePrepared;
    if (preparedSignature && preparedSignature !== "") {
      await getImage(preparedSignature, folderwld, setPreviewuser);
    }
  };

  // const fetchapproveUserProfileswldapproved = async () => {
  //   getImage(props?.rowdata?.wpq_signatureApproved, folderwld, setPreviewapproved)
  // };

  const fetchapproveUserProfileswldapproved = async () => {
    // Check both props.rowdata and pdf[0] for signature data
    let approvedSignature = props?.rowdata?.wpq_signatureApproved || pdf[0]?.wpq_signatureApproved;
    if (approvedSignature && approvedSignature !== "") {
      await getImage(approvedSignature, folderwld, setPreviewapproved);
    }
  };

  const downloadPdf = () => {
    setTimeout(() => {
      let doc = new jsPDF('p', 'pt', [595.28, 1020]);
      doc = Jspdf_font(doc)
      let pdfjs = document.querySelector('#MainDiv');
      doc.html(pdfjs, {
        callback: function (doc) {
          let Filename = `WPQ Report ${pdf[0].wld_WPSType}`
          doc.save(Filename);
          props.onHide();
          props.setReload(!props.reload);
          setLoading(false);
          doc.setFontSize(10);
        }, margin: [-25, 10, 10, 10]
      });
    }, 9000);
  }


  useEffect(() => {
    if (pdf.length > 0) {
      Promise.all([fetchimagespdf(), fetchapproveUserProfileswld(), fetchapproveUserProfileswldapproved()]).then(() => {
        downloadPdf();
      });
    }
  }, [pdf]);

  return (
    <>
      <Modal
        {...props}
        size="sm"
        centered
        transparent={true}
        className={
          showForm || showSuccessModel || showConfirmModel
            ? "opacity-0 userMasterModal"
            : "opacity-100 userMasterModal"
        }
        backdrop="static"
      >
        <Modal.Body
          style={{
            maxHeight: "calc(10vh - 10px)",
          }}
        >
          <p>
            {loading && (
              <BarLoader
                color="blue"
                height={8}
                width={196}
                className="shift"
              />
            )}
          </p>
        </Modal.Body>
      </Modal>
      {pdf.length > 0 && (
        <div id="MainDiv">
          <br></br>
          {pdf[0]?.wld_WPSType === "Tubesheet" ? (
            <>
              <WPQTubeToTubesheet_pdf_page1
                pdf={pdf}
                previewUrl={PreviewUrl}
                previewUrl1={previewUrl1}
                previewUrl2={previewUrl2}
              />
              <div style={{ backgroundColor: "none", height: "45px", position: "relative", top: "10px" }}></div>
              <br></br>
              <WPQTubeToTubesheet_pdf_page2
                pdf={pdf}
                PreviewUrl={PreviewUrl}
                setpdf={setpdf}
                previewuser={previewuser}
                previewapproved={previewapproved}
              />
              <div style={{ backgroundColor: "none", height: "230px", position: "relative", top: "10px" }}></div>
            </>
          ) : (
            <Groove_pdf_page1WPQ
              pdf={pdf} Band={props.Band}
              setpdf={setpdf}
              previewuser={previewuser}
              previewapproved={previewapproved}
            />
          )}
        </div>
      )}
    </>
  )
}


export default Pdf_DownloadWPQ;